import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useStateContext } from "../../contexts/ContextProvider";
import ModuleDisabledPage from "../modules/ModuleDisabledPage";

// Les routes /events* n'existent que si le module Événements est actif sur l'établissement
// sélectionné : sinon, la page « module désactivé » (comme les sociétés).
export default function HotelEventsModuleGuard() {
    const { t } = useTranslation('navigation');
    const { currentFacility } = useStateContext();

    // Établissement pas encore chargé : on attend plutôt que d'afficher à tort « désactivé ».
    if (!currentFacility) {
        return null;
    }

    if (!currentFacility.admin_has_events) {
        return <ModuleDisabledPage moduleName={t('menu.events')} />;
    }

    return <Outlet />;
}
